export const FUTURE_MILESTONES_NAME_TEST_ID = 'FutureMilestoneName';
export const FUTURE_MILESTONES_TEST_ID = 'FutureMilestone';
export const FUTURE_MILESTONES_HEADING_TEST_ID = 'FutureMilestoneHeading';
